import * as leadformConstants from '../constants';

export default function getFields(element){
  return [...element.querySelectorAll(leadformConstants.leadformTagNames.fields.join(','))];
}
